function setupWebViewJavascriptBridge(callback) {
  if (window.flutter_inappwebview) {
    callback(window.flutter_inappwebview)
  } else {
    document.addEventListener(
      'flutterInAppWebViewPlatformReady',
      function () {
        callback(window.flutter_inappwebview)
      },
      false
    );
  }
}

module.exports =  {
  // js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
  callHandler(name, data, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler(name, data).then(result => {
        callback(result)
      })
    })
  },
  // APP调js方法 （参数分别为:js提供的方法名  回调）
  registerHandler(name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        callback(data, responseCallback)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/libs/JSBridge.js